/**
 * HUB-C — Carte preuve de paiement boutique (DS Remobiles).
 */
import React from 'react';
import { Image, Package, ThumbsUp, ThumbsDown, CheckCircle } from 'lucide-react';
import { formatPaymentDate } from '../../utils/paiements/paiementsDisplay';

export default function ActivitePaiementsProofCard({ order, actions, testIdPrefix = 'activite-paiements' }) {
  const validated = order.payment_proof?.validated;

  return (
    <article
      className="rounded-xl border p-4"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-proof-card-${order.id}`}
    >
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2 mb-2">
            <Package className="w-4 h-4 text-[var(--rm-gray-400)]" />
            <span className="font-semibold text-[var(--rm-white)]">
              {order.ref_commande || 'Commande'} — {order.client_nom}
            </span>
            <span className={validated ? 'rm-badge rm-badge--success' : 'rm-badge rm-badge--muted'}>
              {validated ? 'Validé' : 'En attente de validation'}
            </span>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
            <div>
              <span className="text-[var(--rm-gray-500)]">Total : </span>
              <span className="font-bold text-[var(--rm-white)]">{Number(order.total || 0).toFixed(2)} €</span>
            </div>
            <div>
              <span className="text-[var(--rm-gray-500)]">Envoyée : </span>
              <span className="text-[var(--rm-gray-300)]">{formatPaymentDate(order.payment_proof?.uploaded_at)}</span>
            </div>
            <div>
              <span className="text-[var(--rm-gray-500)]">Par : </span>
              <span className="text-[var(--rm-gray-300)]">{order.payment_proof?.uploaded_by || '—'}</span>
            </div>
            {order.payment_proof?.validated_by && (
              <div>
                <span className="text-[var(--rm-gray-500)]">Validé par : </span>
                <span className="text-[var(--rm-success)]">{order.payment_proof.validated_by}</span>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {order.payment_proof && (
            <button
              type="button"
              onClick={() => actions.viewProof(order.id, order.payment_proof.file_id)}
              className="btn-secondary px-4 py-2.5 min-h-[56px] text-sm inline-flex items-center gap-2"
              data-testid={`${testIdPrefix}-view-proof-${order.id}`}
            >
              <Image className="w-4 h-4" />
              Voir capture
            </button>
          )}
          {order.payment_proof && !validated && (
            <>
              <button
                type="button"
                onClick={() => actions.validateProof(order.id)}
                className="btn-success px-4 py-2.5 min-h-[56px] text-sm inline-flex items-center gap-2"
                data-testid={`${testIdPrefix}-validate-proof-${order.id}`}
              >
                <ThumbsUp className="w-4 h-4" />
                Valider
              </button>
              <button
                type="button"
                onClick={() => actions.rejectProof(order.id)}
                className="px-4 py-2.5 min-h-[56px] text-sm inline-flex items-center gap-2 rounded-xl font-semibold border"
                style={{ borderColor: 'var(--rm-border-strong)', background: 'var(--rm-red-muted)', color: 'var(--rm-red-light)' }}
                data-testid={`${testIdPrefix}-reject-proof-${order.id}`}
              >
                <ThumbsDown className="w-4 h-4" />
                Refuser
              </button>
            </>
          )}
          {validated && order.statut === 'payee' && (
            <button
              type="button"
              onClick={() => actions.confirmOrder(order.id)}
              className="btn-secondary px-4 py-2.5 min-h-[56px] text-sm inline-flex items-center gap-2"
              data-testid={`${testIdPrefix}-confirm-order-${order.id}`}
            >
              <CheckCircle className="w-4 h-4" />
              Confirmer commande
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
